import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService, BASE_URL_CRUD } from '../app.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class SettingsService extends AppService {

  // Observable Settings (por ahora implementado solo para currency config)
  _settings = new BehaviorSubject<any>(null);
  observableSettings$ = this._settings.asObservable();


  // actualizamos data de observable Settings
  updateObservableSettings(data: any) {
    this._settings.next(data);
  }

  constructor(http: HttpClient) {
    super(http);
  }

  getSettings(community: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/settings`;
    return this.get(this.endpoint);
  }

  getCurrentPeriod(community: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/period/current`;
    return this.get(this.endpoint);
  }

  postUnitCommonExpense(community: number, data): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/unit/common-expense`;
    return this.create(this.endpoint, data);
  }

  postLightCut(community: number, form: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/configuration/community/${community}/suspense-light`;
    return this.create(this.endpoint, form);
  }

  setCheckControlStatus(communityId: number, status: boolean): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/set-status-control-check`;
    return this.update(this.endpoint, { status });
  }

  getPropertyListCut(community: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${community}/suspense-light/list`;
    return this.get(this.endpoint);
  }

  getCode(communityId: number, fieldKey: string): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/code/${fieldKey}`;
    return this.get(this.endpoint);
  }

  setCode(communityId: number, fieldKey: string, code: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/code/${fieldKey}`
    return this.update(this.endpoint, { value: code });
  }

  setCommonExpense(communityId: number, data: any[]) {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/setting/common-expense`
    return this.update(this.endpoint, data);
  }
}




// WEBPACK FOOTER //
// ./src/app/services/settings.service.ts